

import React, { useState } from 'react'
import { styled } from "@mui/material/styles";
import { Container, Box, Paper, Typography, Divider, Grid, Button } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import CustomUserCard from '../../../Components/CustomUserCard/CustomUserCard';


const ProfileContainer = styled(Box)(({ theme }) => ({
    backgroundColor: "#f5f5f5",
    // minHeight: "100vh",
    padding: theme.spacing(2),
}));


const ResponsiveBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
    },
}));

const AllUsers = ({ addComponent: AddComponent, title, buttonText, tableData, tableHeadData }) => {
    const [uploadedFile, setUploadedFile] = useState(null);

    const [showEvents, setShowEvents] = useState(false);
    const navigate = useNavigate()
    const handleNavigate = () => {
        navigate(-1)
    }

    const handleAddNavigate = () => {
        setShowEvents(true); // toggle the view
    };

    const handleAddFormGoBackButton = () => {
        setShowEvents(false)
    }


    if (showEvents) {

        return <AddComponent handleAddFormGoBackButton={handleAddFormGoBackButton} />;
    }




    // const handleAddNavigate = () => {
    //     navigate("/eventadd")
    // }

    return (
        <Box>
            <Box
            // data-aos="zoom-in" data-aos-duration="1000"
            //     sx={{
            //         position: 'relative',
            //         backgroundColor: "#f5f5f5",

            //     }}
            >
                <Box>
                    <ProfileContainer p={{ xs: 0 }} mb={2} >
                        <Container maxWidth="lg" >
                            <ResponsiveBox mt={2}>
                                <Paper elevation={3} sx={{ p: 3, flex: 1 }}>
                                    <Typography variant="h6" gutterBottom>More suggestions for you</Typography>
                                    <Divider />
                                    <CustomUserCard />
                                    
                                </Paper>
                            </ResponsiveBox>
                        </Container>
                    </ProfileContainer>
                </Box>
                {/* <Box>
                    <ProfileContainer p={{ xs: 0 }} mb={2} >
                        <Container >
                            <ResponsiveBox mt={2}>
                                <Paper elevation={3} sx={{ p: 3, flex: 1, width: { md: "100px" } }}>
                                    <CustomTable handleAddNavigate={handleAddNavigate} tableReportSearch={false} registrationConfirmed={false} tableActions={true} tableEdit={true} tableData={tableData} tableHeadData={tableHeadData} title="Cygnusa Registration Confirmation" />


                                </Paper>

                            </ResponsiveBox>
                        </Container>
                    </ProfileContainer>
                </Box> */}
            </Box>

        </Box>
    )
}

export default AllUsers